import { PartComponent } from "../../../app/reference/models/part-component";

export class PartComponentOption extends PartComponent {
    constructor(partComponent: PartComponent) {
        super(partComponent.name, partComponent.groupName, partComponent.code);
    }

    // This format could differ from the UI display format.
    public get searchText(): string {
        // console.count('PartComponentOption.searchText getter called');
        return `${this.groupName} > ${this.name}`;
    }
}